/* fizzy-mission-collection-highlight
   Title tablist swaps the active title, the description/button preview,
   and the product card in sync. */
(function () {
  function initSection(root) {
    if (root.__fmchInit) return;
    root.__fmchInit = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fmch-tab]'));
    var previews = Array.prototype.slice.call(root.querySelectorAll('[data-fmch-preview]'));
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-fmch-product]'));
    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      previews.forEach(function (el, i) {
        var on = i === index;
        el.hidden = !on;
        el.classList.toggle('is-active', on);
      });
      products.forEach(function (el, i) {
        var on = i === index;
        el.hidden = !on;
        el.classList.toggle('is-active', on);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
      tab.addEventListener('mouseenter', function () {
        activate(i);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (next !== null) {
          e.preventDefault();
          activate(next);
          tabs[next].focus();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fmch]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fmch]');
    if (root) initSection(root);
  });
})();
